import { create } from 'zustand';
import type { MeUser } from '@/types/api';

interface AuthState {
  user: MeUser | null;
  status: 'idle' | 'loading' | 'authenticated' | 'unauthenticated' | 'error';
  error: string | null;
  setUser: (user: MeUser | null) => void;
  setStatus: (status: AuthState['status']) => void;
  setError: (error: string | null) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  status: 'idle',
  error: null,
  setUser: (user) => set({ user, status: user ? 'authenticated' : 'unauthenticated' }),
  setStatus: (status) => set({ status }),
  setError: (error) => set({ error, status: error ? 'error' : 'idle' }),
  reset: () => set({ user: null, status: 'idle', error: null }),
}));
